import Image from 'app/Components/Shared/Image/image';
import React, {useCallback} from 'react';
import './SubscriberCard.scss';
import iconPlus from './images/plus.svg';
import iconMusic from './images/music.svg';
import {formatPhone} from 'app/utilities/StringHelpers/StringHelpers';

const SubscriberCard = (props) => {
  const {subscriberName = ' ', phoneNumber = '', hasService = false, onAdd, onClick, isSelected = false, className = '', subscriberObj} = props;
  const handleCardClick = useCallback(
    (e) => {
      if (e.target.closest('.subscriber-card-icon')) return;
      onClick && onClick(subscriberObj);
    },
    [subscriberObj, onClick],
  );

  const handleIconClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (!hasService && onAdd) {
        onAdd && onAdd(subscriberObj);
      }
    },
    [subscriberObj, hasService, onAdd],
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onClick && onClick(subscriberObj);
      }
    },
    [subscriberObj, onClick],
  );

  const handleIconKeyDown = useCallback(
    (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && !hasService) {
        e.preventDefault();
        e.stopPropagation();
        onAdd && onAdd(subscriberObj);
      }
    },
    [subscriberObj, hasService, onAdd],
  );

  return (
    <div
      className={`funtone-subscriber-card ${isSelected ? 'selected' : ''} ${hasService ? 'has-service' : 'needs-service'} ${className}`}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role='button'
      aria-pressed={isSelected}
      
      tabIndex={0}>

      <div className='subscriber-card-info'>
        <p className='subscriber-card-name'>{subscriberName}</p>
        <p className='subscriber-card-number'>{formatPhone(phoneNumber)}</p>
      </div>

      <div
        className={`subscriber-card-icon ${hasService ? 'music' : 'plus'}`}
        onClick={handleIconClick}
        onKeyDown={handleIconKeyDown}
        role={hasService ? 'img' : 'button'}
        aria-label={hasService ? 'Has service' : 'Add service'}
        tabIndex={hasService ? -1 : 0}>
        {hasService ? (
          <Image src={iconMusic} alt='Music note' className='icon-music' />
        ) : (
          <Image src={iconPlus} alt='Add' className='icon-plus' />
        )}
      </div>

    </div>
  );
};

export default SubscriberCard;
